import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    GET_PATIENT_DROPDOWN_LIST,
    getPatientDropdownListFail,
    getPatientDropdownListSuccess
} from '../action/getPatientDropdownListAction'

// api 
import getPatientDropdownListApi from '../api/getPatientDropdownListApi'

export function* getPatientDropdownListSaga(action) {
    try {
        const response = yield call(() => getPatientDropdownListApi(action.params))
        console.log("REsponse",response.data.status)
        console.log("myres",response.data)
        if (response.data.statusCode === 200) {
            yield put(getPatientDropdownListSuccess(response, action))
        } else {
            yield put(getPatientDropdownListFail(response, action))
        }
    }
    catch (e) {
        yield put(getPatientDropdownListFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(GET_PATIENT_DROPDOWN_LIST, getPatientDropdownListSaga)
}